import React from 'react';

import { YouTubeProps } from 'react-youtube';

import {
  FrameContainer,
  StyledReactYoutube,
  YouTubeRedirectBlock,
  YouTubeTopBlock,
} from './index.styles';

interface YouTubeVideoProps extends YouTubeProps {
  autoplay?: boolean,
}

const YouTubeVideo = ({ autoplay = true, ...props }: YouTubeVideoProps) => {
  // It's possible to check when YouTube goes into full screen using the below code,
  // but it's not possible to render anything on top of the full screen video.
  // Use the below code if we're able to figure it out
  //
  // const [isFullScreen, setIsFullScreen] = React.useState(false);

  // const onFullScreen = () => {
  //   if (document.fullscreenElement) {
  //     setIsFullScreen(true);
  //   } else {
  //     setIsFullScreen(false);
  //   }
  // };

  // document.addEventListener('fullscreenchange', onFullScreen);
  // document.addEventListener('webkitfullscreenchange', onFullScreen);

  const opts = {
    width: '100%',
    height: '100%',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      // Causes the player to not respond to keyboard controls
      disablekb: 1,
      // Causes closed captions to be shown by default
      cc_load_policy: 1,
      // Sets the player's interface language to english
      hl: 'en',
      // Related videos only come from the same channel as the video that was just played
      rel: 0,
      // Hides the YouTube logo
      modestbranding: 1,
      // Starts playing the video as soon as it loads
      autoplay: autoplay ? 1 : 0,
    },
    host: 'https://www.youtube-nocookie.com',
  };

  return (
    <FrameContainer>
      <StyledReactYoutube
        opts={opts}
        {...props}
      />
      <YouTubeTopBlock />
      <YouTubeRedirectBlock />
    </FrameContainer>
  );
};

export default YouTubeVideo;
